import React from 'react'
import { useTranslation } from 'react-i18next'
import { Text } from '@pandiafi/components'

import { ReservationsDataLoader } from './ReservationsDataLoader'
import { ReservationPincode } from './ReservationPincode'
import { generateReservationLocationName } from './reservationNaming.util'
import {
  formatDate,
  formatTimeRange,
  getWeekdayTranslationKey,
} from '../../utils/dateUtils'
import { useCurrentContract } from '../../hooks/useCurrentContract/useCurrentContract'

type ReservationsListProps = {
  reservableCategory?: string
}

export const ReservationsList: React.FC<ReservationsListProps> = ({
  reservableCategory,
}) => {
  const { t } = useTranslation(['reservations'])
  const { currentContractId } = useCurrentContract()
  const selectedCategories = reservableCategory?.split(',') ?? []
  return (
    <ReservationsDataLoader>
      {(reservations) => {
        const filteredReservations = reservations.filter((reservation) =>
          selectedCategories.includes(reservation.reservableCategory)
        )
        return (
          filteredReservations.length > 0 && (
            <div className="space-y-1">
              <div>
                <Text element="div" size="l" weight="bold">
                  {t('reservations:myReservations')}
                </Text>
              </div>
              <div>
                {filteredReservations.map((reservation) => (
                  <div
                    key={`${reservation.id}-${reservation.reservationCalendarId}`}
                    className="mb-4"
                  >
                    <div>
                      {generateReservationLocationName(
                        reservation.calendarMeta,
                        t
                      )}
                    </div>
                    {!reservation.recurring ? (
                      <>
                        <div>
                          {t(getWeekdayTranslationKey(reservation.startsAt))}{' '}
                          {formatDate(reservation.startsAt)}
                        </div>
                        <div>
                          {formatTimeRange(
                            reservation.startsAt,
                            reservation.endsAt
                          )}
                        </div>
                        <ReservationPincode
                          contractUuid={currentContractId}
                          reservationId={reservation.id}
                          reservationRecurrenceId={
                            reservation.reservationRecurrenceId
                          }
                          recurring={reservation.recurring}
                        />
                      </>
                    ) : (
                      <>
                        <div>
                          {t(getWeekdayTranslationKey(reservation.startsAt))}{' '}
                          {formatTimeRange(
                            reservation.startsAt,
                            reservation.endsAt
                          )}
                        </div>
                        <div>
                          {t('reservations:timeFormatting.beginningFrom')}{' '}
                          {formatDate(reservation.startsAt)}
                        </div>
                        <ReservationPincode
                          contractUuid={currentContractId}
                          reservationId={reservation.id}
                          reservationRecurrenceId={
                            reservation.reservationRecurrenceId
                          }
                          recurring={reservation.recurring}
                        />
                      </>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )
        )
      }}
    </ReservationsDataLoader>
  )
}
